var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2183 28.0379H22.6039L31.4203 17.4284L33.5506 12.0003L34.0238 6.2387L35.6555 3.49023L40.1662 5.24519L42.9273 13.4852L40.9657 22.0768V25.3728H51.8978L48.5729 57.5694L42.9273 56.3094H27.2778L21.672 52.9191L18.2129 51.6247L18.2183 28.0379Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5156 52.8984H18.082C21.5122 52.8984 22.4005 57.4726 27.2303 57.4726H39.3772",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5156 52.8984H18.082C21.5122 52.8984 22.4005 57.4726 27.2303 57.4726H39.3772",
    stroke: "#262836",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1038 33.0801H50.6333C48.6307 33.0801 47.0073 34.7035 47.0073 36.706V38.6024C47.0073 40.6049 48.6307 42.2283 50.6333 42.2283H57.1038C59.1063 42.2283 60.7297 40.6049 60.7297 38.6024V36.706C60.7297 34.7035 59.1063 33.0801 57.1038 33.0801Z",
    fill: "white",
    stroke: "#262836",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5798 23.9316H49.1093C47.1068 23.9316 45.4834 25.555 45.4834 27.5576V29.454C45.4834 31.4565 47.1068 33.0799 49.1093 33.0799H55.5798C57.5824 33.0799 59.2058 31.4565 59.2058 29.454V27.5576C59.2058 25.555 57.5824 23.9316 55.5798 23.9316Z",
    fill: "white",
    stroke: "#262836",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5798 42.2266H49.1093C47.1068 42.2266 45.4834 43.85 45.4834 45.8525V47.7489C45.4834 49.7514 47.1068 51.3748 49.1093 51.3748H55.5798C57.5824 51.3748 59.2058 49.7514 59.2058 47.7489V45.8525C59.2058 43.85 57.5824 42.2266 55.5798 42.2266Z",
    fill: "white",
    stroke: "#262836",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.532 51.377H46.0615C44.0589 51.377 42.4355 53.0003 42.4355 55.0029V55.3746C42.4355 57.3771 44.0589 59.0005 46.0615 59.0005H52.532C54.5345 59.0005 56.1579 57.3771 56.1579 55.3746V55.0029C56.1579 53.0003 54.5345 51.377 52.532 51.377Z",
    fill: "white",
    stroke: "#262836",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5153 23.9316H1.27002V57.4734H16.5153V23.9316Z",
    fill: "#386BFF",
    stroke: "#262836",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0212 45.2771C32.4533 43.9923 35.421 41.7073 37.5403 38.7176C39.6596 35.7278 40.833 32.171 40.9089 28.5071V20.8926C40.9089 19.7848 42.4336 17.341 42.4336 12.3843C42.4336 7.36599 41.5271 5.5113 39.3842 2.74652C37.2231 -0.0490867 33.2853 0.752291 33.2853 3.44818V5.64729C33.2853 11.6754 31.0735 15.7583 27.0686 20.2653L21.0858 26.9914H18.04",
    stroke: "#262836",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89355 28.5059V34.6047",
    stroke: "#262836",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.cddcd0212493b846b71fb72f25e6d39f.svg";
export { ForwardRef as ReactComponent };